const FetchService = {
    send: function (url, method, data, okCallBack, errorCallBack) {
        fetch(url, {
            method: method,
            body: data
        })
            .then(function (response) {
                var i = 0;
                if (response.ok) {
                    if (response.status == 200) {
                        return response.json();
                    } else {
                        return null;
                    }
                }
                else {
                    throw "Ha ocurrido un error enviando el formulario, por favor revise que la información sea correcta e inténtelo nuevamente.";
                }
            })
            .then(function (item) {
                var i = 0;
                okCallBack(item);
            })
            .catch(function (err) {
                var i = 0;
                errorCallBack(err);
            });
    },

    sendJson: function (url, method, data, okCallBack, errorCallBack) {
        fetch(url, {
            method: method,
            body: data,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) {
                var i = 0;
                if (response.ok) {
                    return response.json();
                }
                else {
                    throw "Ha ocurrido un error enviando el formulario, por favor revise que la información sea correcta e inténtelo nuevamente.";
                }
            })
            .then(function (item) {
                var i = 0;
                okCallBack(item);
            })
            .catch(function (err) {
                var i = 0;
                errorCallBack(err);
            });
    } 
}

export default FetchService